'use strict';

module Patersons {
    export class MorningStarXrayPortfolio {
        holdingAllocation: Array<MorningStarXrayIdentifier>;
        apiOptions: string = '{type: 3}';
        benchmark: MorningStarXrayIdentifier;
        constructor() {
            this.holdingAllocation = new Array<MorningStarXrayIdentifier>();
            this.benchmark = new MorningStarXrayIdentifier('EUCA000620', 'MSID', 0); // the morningstar MSID they gave us...it will probably change
        }
    }
    export class MorningStarXrayIdentifier {
        Identifier: string;
        IdentifierType: string;
        Amount: number;
        constructor($identifier, $type, $amount) {
            this.Identifier = $identifier;
            this.IdentifierType = $type;
            this.Amount = $amount;
        }
    }
}